import { ScheduledQuery } from '@api/api/scheduled-queries';
import { isMentionType, Mention } from '@design/chat/mention-composer';

import { defaultPromptFormValue, PromptFormValue } from '../PromptForm';

export const scheduledQueryToPromptFormValue = (
  task: ScheduledQuery,
  scheduleEnabled: boolean
): PromptFormValue => {
  const { cadence } = task;

  const mentions: Mention[] = (task.request.mentions ?? []).flatMap(mention =>
    isMentionType(mention.type) ? [{ ...mention, type: mention.type }] : []
  );

  return {
    title: task.title,
    query: task.request.message,
    mentions,
    scheduleEnabled,
    frequency:
      cadence?.day_of_month !== undefined
        ? 'monthlyByDate'
        : (cadence?.frequency ?? defaultPromptFormValue.frequency),
    day: cadence?.day_of_week ?? defaultPromptFormValue.day,
    occurrence: cadence?.occurrence ?? defaultPromptFormValue.occurrence,
    dayOfMonth: cadence?.day_of_month ?? defaultPromptFormValue.dayOfMonth,
    deliveryTime: cadence?.time_window ?? defaultPromptFormValue.deliveryTime,
    skipWeekends: cadence?.skip_weekends ?? defaultPromptFormValue.skipWeekends,
    rollToBusinessDay:
      cadence?.roll_to_business_day ?? defaultPromptFormValue.rollToBusinessDay,
  };
};
